<template>
  <v-container fluid id="docForm">
    <v-card>
      <v-toolbar color="secondary" dense flat>
        <v-toolbar-title>Incoming Transfer Preview / Receiving</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/incoming-transfers">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row class="mb-2">
          <v-col cols="12" md="4">
            <div style="font-weight: bold; font-size: 20px; margin-top: 10px">
              From:
              <span class="custom-accent">{{ transferDraft.fromStore && transferDraft.fromStore.Name }}</span>
            </div>
          </v-col>

          <v-col cols="12" xs="12" sm="3" md="3">
            <span style="font-weight: bold; font-size: 16px">Date: {{ transferDraft.CreatedAt | date }}</span>
          </v-col>

          <v-col cols="12" xs="12" sm="3" md="3">
            <v-btn text @click="printViaThermal" v-show="canPrintTransferDelivery == 'Y'" color="primary" class="float-right">
              <v-icon color="black" left>mdi-file-pdf-box</v-icon> Print Via Thermal
            </v-btn>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row dense class="subtitle-2 text--primary mt-4">
          <v-col cols="12" xs="12" sm="12" md="12">
            <v-data-table :mobile-breakpoint="0" light :items-per-page="pageItems" :headers="headers"
              :items="transferList" item-key="LineNum" hide-default-footer disable-sort>
              <template v-slot:item.index="{ index }">
                <span>{{ index + 1 }}</span>
              </template>

              <!-- selling price template -->
              <template v-slot:item.buyingPrice="{ item }">
                <span v-show="generalSettings.ShowBpSalesUi == 'Y'"> {{ item.buyingPrice | currency }} </span>
              </template>
              <!-- end -->

              <!-- selling price template -->
              <template v-slot:item.sellingPrice="{ item }">
                {{
                  item.sellingPrice | currency
                }}
              </template>
              <!-- end -->
              <!--  quantity template -->
              <template v-slot:item.quantity="{ item }">
                <span>{{ item.quantity }}</span>
              </template>
              <!-- end -->
            </v-data-table>
          </v-col>

          <v-col cols="12" md="12" class="mt-4">
            <v-btn class="float-right" @click="acceptStockTransfer" :loading="loader" color="primary">
              <v-icon left>mdi-check</v-icon>Accept / Receive Stock
            </v-btn>
          </v-col>
        </v-row>

        <v-divider class="mt-4 mb-2"></v-divider>

        <v-row>
          <v-col cols="12" md="12" v-if="insufficientItems.length > 0">
            <v-alert type="error" color="error" density="compact" border="left" colored-border>
              <div>
                <strong>The following items have insufficient stock:</strong>
              </div>
              <ul>
                <li v-for="(item, index) in insufficientItems" :key="index">
                 <span style="color: red"> {{ item.product_name }} :  Required Qty: {{ item.required_qty }} --  Available Qty: {{ item.available_qty }} -- Less By : {{ item.less_by }}</span>
                </li>
              </ul>
            </v-alert>

          </v-col>
        </v-row>

            <!-- printer div -->
        <div id="print" v-show="showPrinterDiv" style>

          <div v-for="(item, index) in receiptHeaders" :key="index" style="font-size: 16px; text-align: center;">
            <div>
              <span style="text-align: center;"> {{ item.rowText }}</span>

            </div>
          </div>
          <br />

          <!-- section 1 -->
          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <div style="text-align: center;">
              <span style="font-size: 20px; font-weight: bold; margin-top: 30px;">STOCK TRANSFER DELIVERY</span><br>
            </div>
          </div>
          <!-- end -->


          <!-- from -->
          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <div style="text-align: center;">
              <span style="font-size: 18px; font-weight: bold;">From: {{ transferDraft.fromStore &&
                transferDraft.fromStore.Name
                }}</span>
            </div>
          </div>
          <br>
          <!-- end -->


          <!-- to store -->
          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <div style="text-align: center;">
              <span style="font-size: 18px; font-weight: bold;">To: {{ transferDraft.toStore &&
                transferDraft.toStore.Name
                }}</span>
            </div>
          </div>
          <!-- end -->

          <span>-------------------------------------------------------</span>

          <div>
            <span style="font-size: 16px;">Date: {{ transferDraft.CreatedAt | date }}</span>
          </div>

          <span>-------------------------------------------------------</span>
          <div
            style="font-size: 14px; white-space: nowrap; display: flex; justify-content: space-between; font-weight: bold;">
            <span style="width: 70%; text-align: left; padding-left: 2px;">Item</span>

            <span style="width: 15%; text-align: left;">Qty</span>

            <span style="width: 15%; text-align: left;">Unit</span>

          </div>
          <span>-------------------------------------------------------</span>

          <div v-for="(item, index) in transferList" :key="index"
            style="font-size: 14px; white-space: nowrap; display: flex; justify-content: space-between; font-weight: bold;">
            <span style="width: 70%; text-align: left; padding-left: 2px; font-weight: bold">{{
              item.product.Name }}
            </span>

            <span style="width: 15%; text-align: left; padding-left: 2px; font-weight: bold">{{
              item.quantity }}
            </span>

            <span style="width: 15%; text-align: left; padding-left: 2px; font-weight: bold">{{
              item.uom && item.uom.UomName }}
            </span>
          </div><br>

          <span>-------------------------------------------------------</span>

          <div>
            <!-- Transferred by: ______________________ -->
          </div>

        </div>
        <!-- end of printing div -->

        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  components: {},
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
    userId() {
      return localStorage.getItem("userId");
    },
    role() {
      return localStorage.getItem("userRole");
    },
    canPrintTransferDelivery() {
      return localStorage.getItem("CanPrintTransferDelivery");
    }
  },
  data() {
    return {
      insufficientItems: [],
      copyObj: null,
      copyData: [{ Name: "Stock Transfer Delivery", id: 12 }],
      transferDraft: {},
      receiptHeaders: [],
      showPrinterDiv: false,
      selectedCustomer: null,
      fromStore: {},
      search: null,
      enableCreate: true,
      isLoading: false,
      smsRef: null,
      select: "",
      searchingProduct: false,
      searchProducts: null,
      products: [],
      customers: [],
      userItem: {},
      userDialog: false,
      TransferDeficit: "",
      pageItems: 500,
      loader: false,
      editItem: {},
      damagedItem: {},
      transferItem: {},
      generalSettings: {},
      store: null,
      UserSign2: null,
      stores: [],
      users: [],
      date: new Date().toISOString().substr(0, 10),
      dialog: false,
      damageDialog: false,
      transferDialog: false,
      dateReadonly: "N",
      searchCustomers: null,
      todayDate: new Date().toISOString().substr(0, 10),
      headers: [
        { text: "NO:", value: "index" },
        { text: "Item Code", value: "product.ItemCode" },
        { text: "Product Name", value: "product.Name" },
        { text: "Qty Transferred", value: "quantity" },
        { text: "Buying Price", value: "buyingPrice" },
        { text: "Imei", value: "imei" },
      ],
      inventory: [],
      transferList: []
    };
  },
  watch: {
    searchProducts(val) {
      if (val && val !== this.select && this.querySelections(val)) {
        this.querySelections(val);
      }
    },
    searchCustomers(val) {
      if (val && val !== this.select && this.queryCustomers(val)) {
        this.queryCustomers(val);
      }
    },
    "$route.params.id": {
      handler: "getById",
      immediate: true
    }
  },
  methods: {
    getById(val) {
      const self = this;
      this.$store
        .dispatch("get", `/stock-transfer-drafts/${val}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.transferDraft = res.ResponseData.transferDraft;
            self.transferList = res.ResponseData.draftRows;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    resetLoader() {
      this.$store.commit("loader", false);
      this.$store.commit("btnLoader", false);
      this.$refs.snackbar.show("Done", "green");
    },
    setDate(date) {
      this.date = date;
    },
    openCreate() {
      this.userDialog = true;
    },
    acceptStockTransfer() {
      const url = `/accept-stock-transfer/${this.transferDraft.id}`;
      const self = this;
      self.loader = true;
      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
              self.$router.push("/transfer-deliveries");
              self.loader = false;
          } 

          if(res.ResultCode == 1500){
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.loader = false;
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
          self.loader = false;
        })
        .finally(() => {
          self.loader = false;
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.generalSettings = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    printViaThermal() {
      // Get the HTML content you want to print
      const content = document.getElementById("print").innerHTML;

      // Open a new print window
      const printWindow = window.open(
        "",
        "",
        "left=0,top=0,width=100,height=auto,toolbar=0,scrollbars=0,status=0"
      );

      // Write the HTML to the print window, including the content
      printWindow.document.write(`
            <html>
            <head>
                <title>Print</title>
                <style>
                body {
                    width: 80mm;
                    margin: 0 auto;
                }
                @page {
                    size: auto;  /* auto is the current printer page size */
                    margin: 0mm; /* this affects the margin in the printer settings */
                }
                </style>
            </head>
            <body onload="window.print(); window.close();">${content}</body>
            </html>
        `);

      printWindow.document.close();
    },
    getReceiptHeaders() {
      this.$store.commit("btnLoader", false);
      const self = this;
      this.$store
        .dispatch("get", `/get-receipt-headers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.receiptHeaders = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getGenSettings();
    this.getReceiptHeaders();
  }
};
</script>;

<style lang="scss" scoped></style>